// React and Hooks
import React, { useEffect, useRef, useState } from "react";
import Static_modal from "../etc/Static_modal";
// Date-related
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker, DatePicker } from "@mui/x-date-pickers";
import Control from "react-leaflet-custom-control";
import { useNavigate } from "react-router-dom";

import { useLocation } from "react-router-dom";

// Styles and CSS

import "leaflet/dist/leaflet.css";
import "leaflet-draw/dist/leaflet.draw.css";

// MUI and Icons
import { GoLocation } from "react-icons/go";
import { FaCircle } from "react-icons/fa";
import { AiOutlineFileAdd } from "react-icons/ai";
import { MdCancel } from "react-icons/md";

// Bootstrap
import Modal from "react-bootstrap/Modal";

// Leaflet and Map-related
import L from "leaflet";
import {
  MapContainer,
  TileLayer,
  FeatureGroup,
  Polygon,
  GeoJSON,
  LayersControl,
} from "react-leaflet";
import { EditControl } from "react-leaflet-draw";
import * as turf from "@turf/turf";
import toGeoJSON from "@mapbox/togeojson";

// Utilities and Services
import axios from "axios";
import JSZip from "jszip";
import AuthService from "../../../services/auth.service.js";
import AuthServiceV2 from "../../../services/auth.serviceV2.js";
import AuthServiceV3 from "../../../services/Operation.serviceV3.js";
import UserService from "../../../services/user.service.js";

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.3.1/images/marker-icon.png",
  iconUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.3.1/images/marker-icon.png",
  shadowUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.3.1/images/marker-shadow.png",
});

function UpdatePolygon() {
  const { state } = useLocation();
  let Navigate = useNavigate();
  let passedOperationID;
  let passedArea;
  let passedTimeStart;
  let passedTimeEnd;
  if (Object.keys(state).length !== 0) {
    passedOperationID = state.passedOperationID;
    passedArea = state.passedArea;
    passedTimeStart = state.passedTimeStart;
    passedTimeEnd = state.passedTimeEnd;
  } else {
    passedOperationID = "";
    passedArea = [];
    passedTimeStart = "";
    passedTimeEnd = "";
  }

  // State management for UI elements
  const [showSuccess, setShowSuccess] = useState(false);
  const [showSendcoop, setShowSendcoop] = useState(false);
  const [showSend, setShowSend] = useState(false);
  const [showError, setShowError] = useState(false);
  const [showErroroperation, setShowErroroperation] = useState(false);
  const [showAgreement, setShowAgreement] = useState(false);
  const [showNoNight, setShowNoNight] = useState(false);
  const [loading, setLoading] = useState(false);
  const [sideBarToggle, setSideBarToggle] = useState(false);
  const [chosenForm, setChosenForm] = useState(1);
  const [agreementPage, setAgreementPage] = useState(1);

  const [populationShow, setPopulationShow] = useState(true);

  // State management for dimensions and window properties
  const [windowSize, setWindowSize] = useState([
    window.innerWidth,
    window.innerHeight,
  ]);

  // State management for date and time
  const presentTime = dayjs(new Date());
  // const desiredLimit = dayjs(new Date() + 1 * 24 * 60 * 60 * 1000);
  const desiredLimit = dayjs(new Date() - 1 * 24 * 60 * 60 * 1000);
  const [dayTimeStart, setDayTimeStart] = useState(
    dayjs(new Date(passedTimeStart)).add(15, "minute")
  );
  const [dayTimeEnd, setDayTimeEnd] = useState(dayjs(new Date(passedTimeEnd)));

  const [coopStartTime, setCoopStartTime] = useState("");
  const [coopEndTime, setCoopEndTime] = useState("");

  // State management for drone and pilot related data
  const [chosenPilot, setChosenPilot] = useState("");
  const [chosenHeight, setChosenHeight] = useState(90);
  const [isTimeBeingSet, setIsTimeBeingSet] = useState(false);
  const [availablePilot, setAvailablePilot] = useState([]);
  const [availableDrone, setAvailableDrone] = useState([]);
  const [availableDroneID, setAvailableDroneID] = useState("");

  // State management for dropdowns and selections
  const [dropdown_id, setDropDown_ID] = useState();
  const [selectedOption, setSelectedOption] = useState("");

  // State management for file operations
  const [filename, setFilename] = useState(undefined);
  const [readFileDone, setReadFileDone] = useState(false);
  const [fileHeight, setFileHeight] = useState([]);

  // State management for mapping and geographical data
  const [simplifiedKMLPosition, setSimplifiedKMLPosition] = useState([]);
  const [wrongFormat, setWrongFormat] = useState(false);
  const [polygonArray, setPolygonArray] = useState([]);
  const [layerArray, setLayerArray] = useState([]);
  const [tempArrayID, setTempArrayID] = useState([]);
  const [polygonToDelete, setPolygonToDelete] = useState([]);
  const [intersection, setIntersection] = useState(false);
  const [areaIntersection, setAreaIntersection] = useState("");
  const [mapposition, setMapPosition] = useState([
    13.101029105523143, 100.92994760607247,
  ]);
  const [specificData, setSpecificData] = useState([]);
  const mapRef = useRef();

  // State management for other functionalities
  const [tempAvailablePurpose, setTempAvailablePurpose] = useState([]);
  const [availablePurpose, setAvailablePurpose] = useState([]);
  const [fetchedPurpose, setFetchedPurpose] = useState([]);
  const [selectedPurpose, setSelectedPurpose] = useState("");
  const [selectedPurposeText, setSelectedPurposeText] = useState([]);
  const [ninetyHeight, setNinetyHeight] = useState(false);
  const [cooperative, setCooperative] = useState(false);
  const [coopUnit, setCoopUnit] = useState("");
  const [searchCoop, setSearhCoop] = useState(false);
  const [CoopId, setCoopId] = useState("");
  const [coopArea, setCoopArea] = useState([]);
  const [modalToggle, setModalToggle] = useState({
    modalSuccess: false,
    modalDenied: false,
    modalErr: false,
    modalwait: false,
  });
  const [textBody, setTextBody] = useState();
  const [isCoopFound, setIsCoopFound] = useState(false);
  const [searchcheck, setSearchcheck] = useState(0);
  const [estimatedInfo, setEstimatedInfo] = useState([]);
  const [isEstimateAble, setIsEstimatable] = useState(true);
  const [prohibitPolygon, setProhibitPolygon] = useState([]);
  const [allReservedArea, setAllReservedArea] = useState([]);
  const [timedReservedArea, setTimedReservedArea] = useState([]);
  const [thailandProvince, setThailandProvince] = useState();
  const [PDRArea, setPDRArea] = useState();
  const [Aerodrome, setAeroDrome] = useState();
  const [hospital, setHospital] = useState();
  const [govOffice, setGovOffice] = useState();
  const [thaiGov, setThaiGov] = useState();
  const [embassy, setEmbassy] = useState();
  const [prohibitedAres, setProhibitedAres] = useState();
  const [restrictedAreas, setRestrictedAreas] = useState();
  const [dangerAreas, setDangerAres] = useState();
  const [bangkokPopulation, setBangkokPopulation] = useState();
  const [policeDepartment, setPoliceDepartment] = useState();
  const [isEdited, setIsEdited] = useState([]);
  const [confirmSend, setConfirmSend] = useState(false);

  const deleteTimerRef = useRef(null);

  const hiddenFileInput = useRef(null);

  const agreementContent = [
    {
      text: "สถานที่ที่จะปฏิบัติการบิน: (คำอธิบายรายละเอียดของตำแหน่งที่ปฏิบัติการบิน หรือขอบเขตของพื้นทีปฏิบัติการอาจจะต้องจัดเตรียมซึ่งอาจระบุไว้ในพิกัดละติจูดและลองจิจูด)",
      status: "-",
    },
    {
      text: "วันและเวลาที่เสนอเพื่อปฏิบัติการบิน (สูงสุด 5 คืน ภายในหนึ่งเดือนตามปฏิทิน)",
      status: "-",
    },
    {
      text: "ระบบเพื่อความปลอดภัยในการบิน ได้แก่ ระบบบันทึกการบิน (Flight Log) และระบบรับรู้ทางภูมิศาสตร์(Geo-Awareness)",
      status: "-",
    },
    {
      text: "ไฟแสดงตำแหน่ง (Navigation Lighting) และควรติดตั้งระบบไฟป้องกันการชน (Strobe or Anti-CollisionLight)",
      status: "-",
    },
    {
      text: "สถานีภาคพื้น (Ground Station)ควบคุม (Remote Controller Software) จะต้องสามารถระบุตำแหน่งของอากาศยานที่เป็นปัจจุบันให้กับนักบินทราบได้หรือซอฟต์แวร์ของชุด",
      status: "-",
    },
    {
      text: "สถานีภาคพื้น (Ground Station)หรือซอฟต์แวร์ของชุดควบคุม (Remote Controller Software) จะต้องสามารถระบุตำแหน่งของอากาศยานที่เป็นปัจจุบันให้กับนักบินทราบได้",
      status: "-",
    },
    {
      text: "ระบบป้องกันการชนและการหลบหลีกสิ่งกีดขวาง",
      status: "-",
    },
    {
      text: "ชุดอุปกรณ์ด้านความปลอดภัย ได้แก่ ชุดสะท้อนแสงรองเท้านิรภัย สำหรับนักบิน บุคลากรและเจ้าหน้าที่ที่เกี่ยวข้องกับการปฏิบัติการบิน",
      status: "-",
    },
    {
      text: "นักบินมีความรู้เกี่ยวกับกฎหมาย กฎระเบียบ ที่เกี่ยวข้องกับอากาศยานซึ่งไม่มีนักบิน และมีความรู้ความชำนาญในการบังคับอากาศยานและใช้ระบบของอากาศยานที่ใช้ในการปฏิบัติการบิน",
      status: "-",
    },
    {
      text: "มีผู้ช่วยสังเกตการบิน (Visual Observer, VO) ซึ่งนักบินรับรองว่าเป็นผู้มีความสามารถปฏิบัติการบินดังกล่าว",
      status: "-",
    },
    {
      text: "มีการสื่อสารที่มีประสิทธิภาพระหว่างนักบิน และผู้ช่วยสังเกตการบินตลอดระยะเวลาในการปฏิบัติการบิน",
      status: "-",
    },
    {
      text: "มีการทำประกันภัยสำหรับความเสียหายอันเกิดแก่ร่างกาย ชีวิต ตลอดจนทรัพย์สินของบุคคลที่สามวงเงินประกันไม่ต่ำกว่าหนึ่งล้านบาทต่อครั้ง",
      status: "-",
    },
    {
      text: "นักบิน และ/หรือ ผู้ช่วยสังเกตการบิน สามารถมองเห็นห้วงอากาศรอบข้างได้ตลอดเวลาปฏิบัติการบิน",
      status: "-",
    },
    {
      text: `นักบินต้องรักษาการสื่อสารที่มีประสิทธิภาพกับผู้ช่วยสังเกตการบิน เพื่อให้ทราบตำแหน่ง ระดับความสูง ท่าทางการบิน 
      และตำแหน่งของอากาศยานอย่างต่อเนื่อง รวมถึงข้อมูลสิ่งกีดขวาง เพื่อหลีกเลี่ยงการชนกันเพื่อความปลอดภัยในการปฏิบัติการบิน`,
      status: "-",
    },
    {
      text: "ผู้ช่วยสังเกตการบินแต่ละคนจะต้องไม่สังเกตการอาากศยานมากกว่า 1 ลำหรือช่วยสนับสนุนนักบินมากกว่าหนึ่งคนในเวลาเดียวกัน และไม่ควรได้รับมอบหมายหน้าที่อื่นๆ พร้อมกัน",
      status: "-",
    },
    {
      text: `ทำการสำรวจพื้นที่ปฏิบัติการและประเมินด้านความปลอดภัย (Conduct site and Flight safety assessment)ในเวลากลางวัน 
      เพื่อให้ทราบสภาพสถานที่ และแนวทางที่เหมาะสมในการปฏิบัติการบินรวมถึงกรอกแบบฟอร์มการสำรวจพื้นที่และแบบฟอร์มที่เกี่ยวข้องให้ครบถ้วน`,
      status: "-",
    },
    {
      text: `จุดบินขึ้นและลง (รวมถึงจุดลงจอดฉุกเฉิน) จะต้องมี แสงสว่างเพียงพอเพื่อให้การมองเห็นที่ชัดเจน 
      เพื่อความปลอดภัยและการอํานวยความสะดวกในการขึ้นและลงของอากาศยาน และป้องกันบุคคลไม่เกี่ยวข้อง เข้ามาในพื้นที่บินขึ้นลง`,
      status: "-",
    },
    {
      text: `จุดบินขึ้นและลง (รวมถึงจุดลงจอดฉุกเฉิน) จะต้องมี แสงสว่างเพียงพอเพื่อให้การมองเห็นที่ชัดเจน 
      เพื่อความปลอดภัยและการอํานวยความสะดวกในการขึ้นและลงของอากาศยาน และป้องกันบุคคลไม่เกี่ยวข้อง เข้ามาในพื้นที่บินขึ้นลง`,
      status: "-",
    },
    {
      text: "นักบินจะต้องได้รับข้อมูลที่เกี่ยวข้อง ได้แก่ ทัศนวิสัย ภาคพื้นดิน ฐานเมฆ ความเร็วลม และปริมาณน้ําฝน ของพื้นที่ปฏิบัติการบินจากกรมอุตุนิยมวิทยา",
      status: "-",
    },
    {
      text: "ไม่ปฏิบัติการบินในพื้นที่หวงห้ามเฉพาะ พื้นที่หวงห้าม เด็ดขาด หรือพื้นที่อันตราย และไม่ทําการบรรทุกวัตถุอันตราย",
      status: "-",
    },
    {
      text: `ต้องปฏิบัติตามข้อกําหนดอื่น ได้แก่ \n
      1.)ปฏิบัติการบินในระยะสายตา \n
      2.)ใช้ระดับความสูงไม่เกิน 300 ฟุต \n
      3.)รักษาระยะห่างด้านข้างกับบุคคล ยานพาหนะ หรือ โครงสร้างที่ไม่เกี่ยวข้องใด ๆ \n
      4.)ไม่ปฏิบัติการบินบรรทุกคน หรือสัตว์ \n
      5.)ไม่ปฏิบัติการบินทิ้งสิ่งของจากอากาศยาน \n
      6.)ไม่ปฏิบัติการบินอากาศยานมากกว่า 1 ลํา ในเวลา เดียวกัน`,
      status: "-",
    },
    {
      text: "บริเวณภาคพื้นดิน สามารถมองเห็นได้ชัดเจน โดย นักบิน ผู้ช่วยสังเกตการบิน และ/หรือพนักงาน สนับสนุน เพื่อให้การบังคับและมองเห็น อากาศยานเป็นไปอย่างมีประสิทธิภาพ",
      status: "-",
    },
    {
      text: "ไม่ปฏิบัติการบินเข้าไปในเมฆ",
      status: "-",
    },
    {
      text: "นักบินต้องสามารถทราบความเร็วลม บริเวณพื้นผิว ของพื้นที่ที่จะปฏิบัติการบินและความเร็วลมไม่เกินกว่าที่บริษัทผู้ผลิตอากาศยานกําาหนด",
      status: "-",
    },
    {
      text: `นักบินจะต้องมีขั้นตอนปฏิบัติที่เหมาะสม และมีกลไก ป้องกันด้านความปลอดภัย (Fail-Safe Mechanism) สําหรับกรณีฉุกเฉินระหว่างการปฏิบัติการบิน 
      เช่นการสูญเสียค่าสั่งควบคุม (Loss of Command) และการ เชื่อมโยงการควบคุม (Control Link) การสูญเสียอุปก รณ์น้าทาง (Loss of Navigation Light)`,
      status: "-",
    },
    {
      text: "กรณีเกิดอุบัติเหตุ ซึ่งมีบุคคลบาดเจ็บหรือทรัพย์สินเกิด ความเสียหาย ให้แจ้งตํารวจ และรายงานฝ่ายมาตรฐานอากาศยานซึ่งไม่มีนักบิน ที่uas ur@caat.or.th โดยเร็วทั้งนี้ไม่เกิน 24 ชั่วโมงนับจากเกิดเหตุ",
      status: "-",
    },
    {
      text: `ผู้ได้รับอนุญาตจะต้องให้รายละเอียดเพิ่มเติม และ/หรือ ผลการสอบสวนภายใน 3 วัน 
      โดยเป็นลายลักษณ์ อักษรทางอีเมล์ที บอร ur@caat.or.th บันทึก เหตุการณ์ ทั้งหมดจะต้องได้รับเก็บการดูแลอย่างเหมาะสม`,
      status: "-",
    },
    {
      text: `ไฟแสดงตําแหน่ง (Navigation Lighting) ต้องเปิดอยู่ ตลอดเวลาในขณะปฏิบัติการบิน เพื่อให้นักบิน และ/หรือผู้ช่วยสังเกตการบินสามารถมองเห็นระบุ คําแหน่ง ทิศทาง ของอากาศยาน`,
      status: "-",
    },
    {
      text: `ก่อนขึ้นปฏิบัติการบิน อากาศยานจะต้องสามารถ เชื่อมต่อสัญญาณดาวเทียมได้ (Achieve a Positive Satellite Lock) อย่างน้อย 7 ดวง`,
      status: "-",
    },
    {
      text: `นักบินจะต้องมีขั้นตอนปฏิบัติที่เหมาะสม และมีกลไกป้องกันความไม่ปลอดภัย (Fail-Safe Mechanism) 
      สําหรับกรณีฉุกเฉินระหว่างการปฏิบัติการบิน เช่นการ สูญเสียค่าสั่งควบคุม (Loss of Command) และ เชื่อมต่อ (Control Link) การสูญเสียไฟนําทาง (Loss of Navigation Light)`,
      status: "-",
    },
    {
      text: `ซอฟต์แวร์ของชุดควบคุม (Remote Controller Software)จะต้องสามารถระบุตําแหน่งของอากาศยานที่เป็นปัจจุบันได้`,
      status: "-",
    },
    {
      text: `มีผู้ช่วยสังเกตการบิน (Visual Observer)`,
      status: "-",
    },
  ];
  const handleClose_Modal = (close) => {
    setModalToggle({
      ...modalToggle,
      modalSuccess: close,
      modalDenied: close,
      modalErr: close,
      modalwait: close,
    });
    setTextBody("");
  };

  const showMyLocation = () => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          if (mapRef.current) {
            mapRef.current.flyTo(
              [position.coords.latitude, position.coords.longitude],
              17,
              {
                animate: true,
              }
            );
          }
        },
        (error) => {
          console.error("Error getting location:", error);
        }
      );
    }
    if (mapRef.current) {
      mapRef.current.flyTo([13.102617437258145, 100.88806223049966], 15, {
        animate: true,
      });
    }
  };

  const handleCreation = (e) => {
    const { layer } = e;
    setLayerArray((previous) => [...previous, layer]);

    let positions = [];

    if (layer instanceof L.Circle) {
      positions = calculateCircleMarkers(layer);
    } else if (layer instanceof L.Polygon) {
      positions = convertPolygonToCoordinates(layer);
    }

    if (positions.length) {
      updateArrays(layer, positions);
    }
  };

  const calculateCircleMarkers = (layer) => {
    const { lat, lng } = layer.getLatLng();
    const circleRadius = layer._mRadius;
    const numPoints = 36;
    const markerPositions = [];
    for (let i = 0; i < numPoints; i++) {
      const angleRad = ((2 * Math.PI) / numPoints) * i;

      const deltaX = circleRadius * Math.cos(angleRad);
      const deltaY = circleRadius * Math.sin(angleRad);

      const newLng = lng + deltaX / (111320 * Math.cos(lat * (Math.PI / 180)));
      const newLat = lat + deltaY / 110574;

      markerPositions.push([newLng, newLat]);
    }

    markerPositions.push(markerPositions[0]);
    return markerPositions;
  };

  const convertPolygonToCoordinates = (polygon) => {
    const latLngs = polygon.getLatLngs()[0];
    const coordinates = latLngs.map(({ lng, lat }) => [lng, lat]);
    coordinates.push(coordinates[0]);
    return coordinates;
  };

  const updateArrays = (layer, positions) => {
    setTempArrayID((previous) => [...previous, layer._leaflet_id]);
    setPolygonArray((previous) => [...previous, positions]);
  };

  function checkAllPolygon() {
    let intersectionCount = 0;
    let turfPolygonArray;

    try {
      turfPolygonArray = polygonArray.map((polygon) => turf.polygon([polygon]));

      if (polygonArray.length > 0) {
        //ตรวจสอบระหว่าง Polygon ที่เพิ่งวาดกันเอง (กรณีวาดได้หลาย Polygon ภายใน 1 ครั้ง)
        for (let i = 0; i < turfPolygonArray.length; i++) {
          const drawnPolygonCoords = turfPolygonArray[i];
          let isIntersecting = false;

          for (let j = 0; j < turfPolygonArray.length; j++) {
            if (
              i !== j &&
              turf.booleanIntersects(turfPolygonArray[j], drawnPolygonCoords)
            ) {
              isIntersecting = true;
              intersectionCount++;
              if (chosenForm === 1) {
                layerArray[i].setStyle({
                  color: "red",
                  fillColor: "lightpink",
                });
              }
              break;
            }
          }

          if (!isIntersecting) {
            for (let k = 0; k < prohibitPolygon.length; k++) {
              //141 is updated
              if (
                turf.booleanIntersects(
                  turf.polygon([prohibitPolygon[k].area]),
                  drawnPolygonCoords
                )
              ) {
                if (k <= 141) {
                  setAreaIntersection(
                    `ทับพื้นที่หวงห้าม \n ${prohibitPolygon[k].name}`
                  );
                } else if (k > 141 && k <= 188) {
                  setAreaIntersection(
                    `ทับพื้นที่การบินของสนามบิน \n ${prohibitPolygon[k].name}`
                  );
                } else if (k > 188 && k <= 10810) {
                  setAreaIntersection(
                    `ทับโรงพยาบาล \n ${prohibitPolygon[k].name}`
                  );
                } else if (k > 10810 && k <= 10860) {
                  setAreaIntersection(
                    `ทับสำนักงานข้าราชการ \n ${prohibitPolygon[k].name}`
                  );
                } else if (k > 10860 && k <= 11023) {
                  setAreaIntersection(
                    `ทับที่สถานฑูต \n ${prohibitPolygon[k].name}`
                  );
                } else if (k > 11023 && k <= 11111) {
                  setAreaIntersection(
                    `ทับที่สถานีตำรวจ \n ${prohibitPolygon[k].name}`
                  );
                } else if (k > 11111 && k <= 11187) {
                  setAreaIntersection(
                    `ทับที่ทำการข้าราชการ \n ${prohibitPolygon[k].name}`
                  );
                }
                isIntersecting = true;
                intersectionCount++;
                if (chosenForm === 1 && simplifiedKMLPosition.length === 0) {
                  layerArray[i].setStyle({
                    color: "red",
                    fillColor: "lightpink",
                  });
                }
                break;
              }
            }
            if (specificData.length > 0) {
              for (let s = 0; s < specificData.length; s++) {
                if (
                  turf.booleanIntersects(
                    turf.polygon([specificData[s]]),
                    drawnPolygonCoords
                  )
                ) {
                  if (chosenForm === 1 && simplifiedKMLPosition.length === 0) {
                    isIntersecting = true;
                    intersectionCount++;
                    layerArray[i].setStyle({
                      color: "red",
                      fillColor: "lightpink",
                    });
                    setAreaIntersection(`ทับที่พื้นที่ที่กำลังขออนุญาติ`);
                  }
                  break;
                }
              }
            }
          }

          if (chosenForm === 1) {
            if (!isIntersecting && simplifiedKMLPosition.length === 0) {
              layerArray[i].setStyle({
                color: "green",
                fillColor: "lightgreen",
              });
            }
          }
        }
      }

      if (intersectionCount > 0) {
        setIntersection(true);
        setShowError(true);
      } else {
        setIntersection(false);
        estimateOperationInfo();
      }
    } catch (err) {
      setWrongFormat(true);
      console.log("Error in the Polygon detection : ", err);
      setShowError(true);
    }
  }

  const handleEdit = (e) => {
    setIsEdited([]);
    const layers = e.layers._layers;
    if (tempArrayID[0] !== undefined) {
    }
    setIsEdited(layers);
  };
  const checkoperator = () => {
    const operatorid = sessionStorage.getItem("operator_id");

    if (operatorid === "null" || operatorid === undefined) {
      setShowErroroperation(true);
      setTimeout(() => {
        setShowErroroperation(false);

        // Navigate("/home");
        // window.location.reload(false);
      }, 2000);
    } else {
      const check = AuthServiceV2.NewToken();
    }
  };
  useEffect(() => {
    console.log(passedArea);
    checkoperator();
    getPurposes();
  }, []);
  useEffect(() => {
    const tempPolygonArrayEdited = [...polygonArray];
    Object.entries(isEdited).forEach(([key, value]) => {
      const index = tempArrayID.findIndex((id) => id === parseInt(key));
      if (value instanceof L.Polygon) {
        tempPolygonArrayEdited[index] = convertPolygonToCoordinates(value);
      } else if (value instanceof L.Circle) {
        tempPolygonArrayEdited[index] = calculateCircleMarkers(value);
      }
    });
    setPolygonArray(tempPolygonArrayEdited);
  }, [isEdited]);

  const handleDelete = (e) => {
    const layers = e.layers;
    const idArray = [];
    clearTimeout(deleteTimerRef.current);
    deleteTimerRef.current = setTimeout(() => {
      layers.eachLayer((layer) => {
        if (layer instanceof L.Polygon) {
          idArray.push(layer._leaflet_id);
        }
        if (layer instanceof L.Circle) {
          idArray.push(layer._leaflet_id);
        }
      });
      setPolygonToDelete(idArray);
    }, 100);
    return () => clearTimeout(deleteTimerRef.current);
  };

  useEffect(() => {
    const indicesToDelete = [];

    polygonToDelete.forEach((id) => {
      const indexToDelete = tempArrayID.findIndex((object) => object === id);
      indicesToDelete.push(indexToDelete);
    });

    const updatedPolygonArray = polygonArray.filter(
      (_, index) => !indicesToDelete.includes(index)
    );
    setPolygonArray(updatedPolygonArray);

    const updatedTempArrayID = tempArrayID.filter(
      (_, index) => !indicesToDelete.includes(index)
    );
    setTempArrayID(updatedTempArrayID);

    const updatedLayerArray = layerArray.filter(
      (_, index) => !indicesToDelete.includes(index)
    );
    setLayerArray(updatedLayerArray);
  }, [polygonToDelete]);

  function timeStringToInt(time) {
    const date = new Date(time);
    return Math.round(date.getTime());
  }

  const shouldDisableStartDate = (date) => {
    return date <= desiredLimit;
  };

  const shouldDisableTime = (date) => {
    return (
      new Date(date).getHours() <= 6 ||
      new Date(date).getHours() >= 17 ||
      (new Date(date).getDate() == new Date(desiredLimit).getDate() + 1 &&
        new Date(date).getHours() <= new Date(desiredLimit).getHours())
    );
  };

  const handleClose = () => {
    setShowSendcoop(false);
    setShowSend(false);
  };

  const handleShow = () => {
    if (chosenForm === 1) {
      console.log(estimatedInfo[1]);
      if (
        selectedOption.length > 0 &&
        selectedPurpose.length > 0 &&
        chosenHeight > 19 &&
        chosenHeight < 16001 &&
        estimatedInfo[1] !== "REPEATED" &&
        estimatedInfo[1] !== "DRONE IN USED" &&
        estimatedInfo[1] !== "PILOT IN USED" &&
        estimatedInfo[1] !== "AREA IN USED" &&
        estimatedInfo[1] !== "INVALID PILOT TYPE" &&
        estimatedInfo[1] !== "OPEN PILOT ONLY" &&
        estimatedInfo[1] !== "SPECIFIC PILOT ONLY"
      ) {
        let estimatedInfoText = estimatedInfo[1].split("||")[1].trim();
        if (estimatedInfoText.split("-")[0] === "OPEN") {
          setShowSend(true);
        } else if (estimatedInfoText.split("-")[0] === "SPECIFIC") {
          setShowAgreement(true);
        }
      } else {
        setShowError(true);
      }
    }
    // else if (chosenForm === 2) {
    //   if (coopUnit.length > 0 || isCoopFound) {
    //     setShowAgreement(true);
    //   } else {
    //     console.log("This !4");
    //     setShowError(true);
    //   }
    // }
    // else if (chosenForm === 3) {
    //   if (filename !== undefined && estimatedInfo[1] !== "REPEATED") {
    //     if (estimatedInfo[1] === "READY-DAY") {
    //       setShowSend(true);
    //     } else {
    //       setShowAgreement(true);
    //       // setShowNoNight(true);
    //     }
    //   } else {
    //     console.log("This !5");
    //     setShowError(true);
    //   }
    // }
  };

  function formattingDate(inputDate) {
    const year = inputDate.getFullYear();
    const month = (inputDate.getMonth() + 1).toString().padStart(2, "0");

    const day = inputDate.getDate().toString().padStart(2, "0");
    const hours = inputDate.getHours().toString().padStart(2, "0");
    const minutes = inputDate.getMinutes().toString().padStart(2, "0");
    const formattedDate = `${year}-${month}-${day}T${hours}:${minutes}:00+07:00`;
    return formattedDate;
  }

  function quickSwapElement(arr) {
    // arr.map((subArr) => console.log(subArr[1], subArr[0]))
    const tempArray = [];
    if (arr.length > 0) {
      for (let i = 0; i < arr.length; i++) {
        const swappedArray = arr[i].map((subArr) => {
          return [subArr[1], subArr[0]];
        });
        tempArray.push(swappedArray);
      }
    }

    // const swappedArray = arr.map((subArr) => {
    //   return [subArr[1], subArr[0]];
    // });
    // console.log("quickSwapElement -> ",swappedArray);
    return tempArray;
  }

  function swapElements(arr) {
    const formattedArray = [];

    if (typeof filename === "undefined") {
      formattedArray.push(
        ...arr[0].map((subArr) => subArr.map((pair) => [pair[1], pair[0]]))
      );
    } else {
      for (let j = 0; j < arr.length; j++) {
        if (arr[j][0] !== undefined) {
          const tempFormattedArray = [];
          for (let k = 0; k < arr[j].length; k += 2) {
            tempFormattedArray.push([arr[j][k + 1], arr[j][k]]);
          }
          formattedArray.push(tempFormattedArray);
        }
      }
    }

    return formattedArray;
  }

  function kmlElement(arr) {
    const formattedArray = [];
    for (let j = 0; j < arr.length; j++) {
      if (arr[j][0] !== undefined) {
        const tempFormattedArray = [];
        for (let k = 0; k < arr[j].length; k += 2) {
          tempFormattedArray.push([arr[j][k], arr[j][k + 1]]);
        }
        formattedArray.push(tempFormattedArray);
      }
    }
    return formattedArray;
  }

  const convert = async (kmzfile) => {
    const zip = new JSZip();
    try {
      const kmzData = await zip.loadAsync(kmzfile);
      const kmlData = await kmzData.file("doc.kml").async("string");
      return kmlData;
    } catch (error) {
      console.error("Error converting KMZ to KML:", error);
      return null;
    }
  };
  async function handleFileInputChange(event) {
    const file = event.target.files[0];

    if (file !== undefined) {
      setFilename(event.target.files[0].name);
      if (event.target.files[0].name.includes(".kmz")) {
        const kmlData = await convert(file);
        update(kmlData);
      } else {
        if (file) {
          const reader = new FileReader();

          reader.onload = function (e) {
            const fileContent = e.target.result;

            update(fileContent);
          };
          reader.readAsText(file);
        }
      }
    }
  }

  const kmlRecursiveRead = (feature) => {
    if (feature.geometry.type === "Polygon") {
      const coordinates = feature.geometry.coordinates[0];
      try {
        const kmlRecursiveReadData = coordinates
          .filter(
            (coord) =>
              !isNaN(coord[0]) &&
              !isNaN(coord[1]) &&
              coord[0] !== undefined &&
              coord[1] !== undefined
          )
          .flatMap((coord) => [coord[0], coord[1]]);
        return [kmlRecursiveReadData];
      } catch (err) {
        return null;
      }
    } else if (feature.geometry.type === "GeometryCollection") {
      const arr = feature.geometry.geometries.map((content) => {
        return kmlRecursiveRead({ geometry: content });
      });
      return arr.flat().filter((content) => content !== null);
    } else {
      return null;
    }
  };

  const update = (fileContent) => {
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(fileContent, "text/xml");
    const geoJsonData = toGeoJSON.kml(xmlDoc);

    if (!geoJsonData) return;
    const positionFileData = geoJsonData.features.map((feature) => {
      return kmlRecursiveRead(feature);
    });
    const arrangedData = positionFileData
      .filter((content) => content !== null)
      .flat();
    const cleanArrangedData = arrangedData.filter(
      (subArray) => subArray.length > 0
    );
    if (cleanArrangedData.length !== 0) {
      const testingP = cleanArrangedData.map((content) => {
        const resultArray = [];
        for (let i = 0; i < content.length; i += 2) {
          if (i + 1 < content.length) {
            resultArray.push([content[i], content[i + 1]]);
          }
        }

        return resultArray;
      });

      setFileHeight(90);
      setReadFileDone(!readFileDone);
      setSimplifiedKMLPosition(cleanArrangedData);
      setPolygonArray(testingP);
      setMapPosition(testingP[0][0]);
      setWrongFormat(false);
    } else {
      setWrongFormat(true);
      console.log("This !6");
      setShowError(true);
    }
  };

  const handleChangeStart = (newValue) => {
    if (timeStringToInt(newValue) >= timeStringToInt(presentTime)) {
      setDayTimeStart(newValue);
      setDayTimeEnd(
        dayjs(new Date(timeStringToInt(newValue))).add(10, "minute")
      );
      const pickedIndex = allReservedArea
        .map((content, index) => {
          if (
            !(
              content.end_time <
                new Date(timeStringToInt(newValue)).getTime() ||
              content.start_time >
                new Date(timeStringToInt(dayTimeEnd)).getTime()
            )
          ) {
            return index;
          }
          return null; // Return null for elements that don't meet the condition
        })
        .filter((index) => index !== null); // Filter out null values
      const areaData = pickedIndex.map(
        (content) => allReservedArea[content].operation_area
      );
      const specificArea = pickedIndex
        .map((content) => {
          if (allReservedArea[content].type === "SPECIFIC") {
            return allReservedArea[content].operation_area;
          }
        })
        .filter((area) => area !== undefined);
      setSpecificData(specificArea);
      setTimedReservedArea(areaData);
    }
  };
  const handleChangeEnd = (newValue) => {
    setDayTimeEnd(newValue);

    const pickedIndex = allReservedArea
      .map((content, index) => {
        if (
          !(
            content.end_time <
              new Date(timeStringToInt(dayTimeStart)).getTime() ||
            content.start_time > new Date(timeStringToInt(newValue)).getTime()
          )
        ) {
          return index;
        }
        return null; // Return null for elements that don't meet the condition
      })
      .filter((index) => index !== null);
    const areaData = pickedIndex.map(
      (content) => allReservedArea[content].operation_area
    );
    const specificArea = pickedIndex
      .map((content) => {
        if (allReservedArea[content].type === "SPECIFIC") {
          return allReservedArea[content].operation_area;
        }
      })
      .filter((area) => area !== undefined);

    setSpecificData(specificArea);
    setTimedReservedArea(areaData);

    layerArray.forEach((data) => {
      data.remove();
    });
    setLayerArray([]);
    setPolygonArray([]);
  };

  const doSearchCooperative = () => {
    findoperation();
    if (searchCoop === true) {
      setSearhCoop(false);
    } else {
      setSearhCoop(true);
    }
  };

  const getPurposes = () => {
    const purposeList = AuthServiceV2.DronePurposes();
    if (purposeList) {
      purposeList.then((response) => {
        const responseData = response.data.data;
        setFetchedPurpose(responseData);
      }).catch((error)=>{
        console.log(error)
      })
    }
  };

  const getOperationAreaData = () => {
    const dataArea = AuthServiceV2.Opearationdata();
    if (dataArea) {
      dataArea
        .then((response) => {
          const responseData = response.data;
          const allAreaData = [];
          if (responseData != undefined) {
            if (
              responseData.agency_data.length > 0 ||
              responseData.agency_data.length !== undefined
            ) {
              for (let i = 0; i < responseData.agency_data.length; i++) {
                const TempAreaData = [];
                const agencyArea =
                  responseData.agency_data[i].operation_area.Volume3D
                    .outline_polygon.vertices;
                for (let j = 0; j < agencyArea.length; j++) {
                  TempAreaData.push([agencyArea[j].Lon, agencyArea[j].Lat]);
                }
                allAreaData.push({
                  start_time: new Date(
                    responseData.agency_data[i].start_time
                  ).getTime(),
                  end_time: new Date(
                    responseData.agency_data[i].end_time
                  ).getTime(),
                  operation_area: TempAreaData,
                });
              }
            }
            for (let i = 0; i < responseData.operator_data.length; i++) {
              const TempAreaData = [];
              if (
                responseData.operator_data[i].operation_status ===
                "หน่วยงานยกเลิกภารกิจ"
              ) {
                setIsEstimatable(false);
              }

              const operatorData =
                responseData.operator_data[i].operation_area.Volume3D
                  .outline_polygon.vertices;

              for (let j = 0; j < operatorData.length; j++) {
                // console.log("operatorData[j] -> ", operatorData[j])
                // const mappedData = operatorData[j].map((content) => [
                //   content.Lon,
                //   content.Lat,
                // ]);
                // mappedData.push(mappedData[0]);
                TempAreaData.push([operatorData[j].Lon, operatorData[j].Lat]);
              }

              allAreaData.push({
                start_time: new Date(
                  responseData.operator_data[i].start_time
                ).getTime(),
                end_time: new Date(
                  responseData.operator_data[i].end_time
                ).getTime(),
                operation_area: TempAreaData,
              });
            }
            // console.log(allAreaData);
            setAllReservedArea(allAreaData);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const legendPopulation = [
    { population: "น้อยกว่า 1000", color: 0.1 },
    { population: "1000-2499", color: 0.2 },
    { population: "2500-4999", color: 0.3 },
    { population: "5000-7499", color: 0.3 },
    { population: "7500-9999", color: 0.5 },
    { population: "10000-14999", color: 0.6 },
    { population: "15000-19999", color: 0.7 },
    { population: "20000-24999", color: 0.8 },
    { population: "มากกว่า 24999", color: 0.9 },
  ];

  const getDrone = () => {
    const startDate = formattingDate(new Date(dayTimeStart));
    const endDate = formattingDate(new Date(dayTimeEnd));
    const droneAndPilotData = AuthServiceV3.DroneAndPilotDataforUpdate(
      passedOperationID,
      startDate,
      endDate
    );
    if (!droneAndPilotData) return;
    droneAndPilotData
      .then((response) => {
        const { dropdown_id, drone_data, pilot_data } = response.data;
        setDropDown_ID(dropdown_id);
        const droneElement = drone_data.map(
          (drone) => `${drone.drone_id}-${drone.brand_model}`
        );
        const purposeElement = drone_data.reduce(
          (acc, drone) => ({ ...acc, [drone.drone_id]: drone.purpose }),
          {}
        );

        const pilotElement = pilot_data.map(
          (pilot) => `${pilot.co_id}-${pilot.pilot_name}-${pilot.pilot_type}`
        );

        setAvailableDrone(droneElement);
        setTempAvailablePurpose(purposeElement);
        setAvailablePilot(pilotElement);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const estimateOperationInfo = () => {
    let positionToPost;
    if (filename !== undefined) {
      positionToPost = kmlElement(simplifiedKMLPosition);
    } else if (polygonArray.length > 0) {
      positionToPost = polygonArray;
    } else if (polygonArray.length === 0) {
      positionToPost = [
        passedArea.map((subArray) => [subArray[1], subArray[0]]),
      ];
    }
    console.log(dropdown_id);
    const checkOperation = AuthServiceV3.CheckUpdateOperation(
      passedOperationID,
      parseInt(chosenPilot.split("-")[0]),
      availableDroneID,
      dropdown_id,
      parseInt(selectedPurpose.split("-")[0]),
      positionToPost,
      chosenHeight,
      2
    );

    if (!checkOperation) return;
    checkOperation
      .then((response) => {
        console.log(response);
        if (response === "You have operation data in this time period") {
          setEstimatedInfo(["-", "REPEATED"]);
          setShowError(true);
        } else if (response === "Drone is in uesd") {
          setEstimatedInfo(["-", "DRONE IN USED"]);
          setShowError(true);
        } else if (response === "Pilot is busy") {
          setEstimatedInfo(["-", "PILOT IN USED"]);
          setShowError(true);
        } else if (
          response === "Pilot cannot do this operation. Use SPECIFIC pilot"
        ) {
          setEstimatedInfo(["-", "SPECIFIC PILOT ONLY"]);
          setShowError(true);
        } else if (
          response === "Pilot cannot do this operation. Use OPEN pilot"
        ) {
          setEstimatedInfo(["-", "OPEN PILOT ONLY"]);
          setShowError(true);
        } else if (response === "This area is already used") {
          setEstimatedInfo(["-", "AREA IN USED"]);
          setShowError(true);
        } else {
          const {
            data: { ID, status },
          } = response;
          setEstimatedInfo([ID, status]);
        }
      })
      .catch((err) => {
        console.log("error ", err);
        setShowError(true);
      });
  };

  useEffect(() => {
    if (estimatedInfo.length !== 0) {
      if (estimatedInfo[1] !== "REPEATED") {
        handleShow();
      }
    }
  }, [estimatedInfo]);

  useEffect(() => {
    // console.log(mapRef," ",mapRef.current)
    if (mapRef && mapRef.current) {
      const map = mapRef.current;

      map.flyTo([mapposition[1], mapposition[0]], 16);
    }
  }, [mapposition]);

  const confirmSendInfo = () => {
    let confirmInfo = AuthServiceV3.ComfirmUpdateOperation(estimatedInfo[0]);
    if (confirmInfo != null) {
      confirmInfo.then((response) => {});
    }
  };
  const getPDFForNight = async (data_id) => {
    setLoading(true);
    let getPDF = AuthServiceV2.NightFlightForm(data_id);
    if (getPDF != null) {
      getPDF.then((response) => {
        setLoading(false);
        // setShowSend(false);
      }).catch((error)=>{
        console.log(error)
      })
    }
  };

  useEffect(() => {
    setSideBarToggle(true);
  }, []);

  useEffect(() => {
    async function fetchData() {
      try {
        const [
          responsePDRArea,
          responseAeroDrome,
          responseHospital,
          responseGovOffice,
          responseEmbassy,
          responsePoliceDepartment,
          responseThaiGov,
          allGeoData,
          responseBangkokPopulation,
        ] = await Promise.all([
          axios.get("../../PDR-AREA.geojson"),
          axios.get("../../Aerodrome.geojson"),
          axios.get("../../hospitalLocation.geojson"),
          axios.get("../../GovOfficetoutput.geojson"),
          axios.get("../../Embassyoutput.geojson"),
          axios.get("../../PoliceDepartmentoutput.geojson"),
          axios.get("../../ThaiGovoutput.geojson"),
          axios.get("../../BKK_District.geojson"),
          AuthServiceV2.AllGeoFenceData().then((res) => {
            return res;
          }),
          
        ]);
        let PDRDataset = {
          type: "FeatureCollection",

          features: [
            ...allGeoData.data.prohibited_areas.features,
            ...allGeoData.data.danger_areas.features,
            ...allGeoData.data.restricted_areas.features,
          ],
        };
        setProhibitedAres(allGeoData.data.prohibited_areas.features);
        setRestrictedAreas(allGeoData.data.restricted_areas.features);
        setDangerAres(allGeoData.data.danger_areas.features);
        setPDRArea(PDRDataset);
        setAeroDrome(allGeoData.data.aerodrome.features);

        setHospital(responseHospital.data);

        setGovOffice(responseGovOffice.data);

        setThaiGov(responseThaiGov.data);

        setPoliceDepartment(responsePoliceDepartment.data);

        setEmbassy(responseEmbassy.data);
        setBangkokPopulation(responseBangkokPopulation.data);

        // const tempAllData = [
        //   ...allGeoData.data.aerodrome.features.map(
        //     (feature) => feature.geometry.coordinates[0][0]
        //   ),
        //   ...allGeoData.data.danger_areas.features.map(
        //     (feature) => feature.geometry.coordinates[0][0]
        //   ),
        //   ...allGeoData.data.other_areas.features.map(
        //     (feature) => feature.geometry.coordinates[0][0]
        //   ),
        //   ...allGeoData.data.prohibited_areas.features.map(
        //     (feature) => feature.geometry.coordinates[0][0]
        //   ),
        //   ...allGeoData.data.restricted_areas.features.map(
        //     (feature) => feature.geometry.coordinates[0][0]
        //   ),

        //   ...responseHospital.data.features.map(
        //     (feature) => feature.geometry.coordinates[0]
        //   ),
        //   ...responseGovOffice.data.features.map(
        //     (feature) => feature.geometry.coordinates[0]
        //   ),
        //   ...responseEmbassy.data.features.map(
        //     (feature) => feature.geometry.coordinates[0]
        //   ),
        //   ...responsePoliceDepartment.data.features.map(
        //     (feature) => feature.geometry.coordinates[0]
        //   ),
        //   ...responseThaiGov.data.features.map(
        //     (feature) => feature.geometry.coordinates[0]
        //   ),
        // ];

        const tempAllData = [
          ...allGeoData.data.aerodrome.features.map((feature) => ({
            area: feature.geometry.coordinates[0][0],
            name: feature.properties.province,
          })),
          ...allGeoData.data.danger_areas.features.map((feature) => ({
            area: feature.geometry.coordinates[0][0],
            name: feature.properties.name,
          })),
          ...allGeoData.data.other_areas.features.map((feature) => ({
            area: feature.geometry.coordinates[0][0],
            name: feature,
          })),
          ...allGeoData.data.prohibited_areas.features.map((feature) => ({
            area: feature.geometry.coordinates[0][0],
            name: feature.properties.name,
          })),
          ...allGeoData.data.restricted_areas.features.map((feature) => ({
            area: feature.geometry.coordinates[0][0],
            name: feature.properties.name,
          })),
          ...responseHospital.data.features.map((feature) => ({
            area: feature.geometry.coordinates[0],
            name: feature.properties.Agency,
          })),
          ...responseGovOffice.data.features.map((feature) => ({
            area: feature.geometry.coordinates[0],
            name: feature.properties.name,
          })),
          ...responseEmbassy.data.features.map((feature) => ({
            area: feature.geometry.coordinates[0],
            name: feature.properties.name_t,
          })),
          ...responsePoliceDepartment.data.features.map((feature) => ({
            area: feature.geometry.coordinates[0],
            name: feature.properties.name,
          })),
          ...responseThaiGov.data.features.map((feature) => ({
            area: feature.geometry.coordinates[0],
            name: feature.properties.name,
          })),
        ];

        setProhibitPolygon(tempAllData);
      } catch (error) {
        console.error("Error fetching JSON data:", error);
      }
    }
    fetchData();
    setTimeout(() => {
      getDrone();
      getOperationAreaData();
    }, 1000);
  }, []);

  const bangkokPopulationColorized = (feature) => {
    const population = feature.properties.DN;
    return {
      fillColor: "red", // Set colors based on categories
      color: "transparent",

      fillOpacity:
        population < 1000
          ? 0.1
          : population >= 1000 && population < 2500
          ? 0.2
          : population >= 2500 && population < 5000
          ? 0.3
          : population >= 5000 && population < 7500
          ? 0.4
          : population >= 7500 && population < 10000
          ? 0.5
          : population >= 10000 && population < 15000
          ? 0.6
          : population >= 15000 && population < 20000
          ? 0.7
          : population >= 20000 && population < 25000
          ? 0.8
          : 0.9,
    };
  };

  const downloadTxtFile = () => {
    const content = `<?xml version="1.0" encoding="UTF-8"?> 
    <kml xmlns="http://earth.google.com/kml/2.0"> 
        <Document>
            <Placemark> 
                <name>Untitled Polygon</name>
                <styleUrl>#m_ylw-pushpin</styleUrl>
                <Polygon>   
                    <tessellate>1</tessellate>
                    <altitudeMode>absolute</altitudeMode>
                    <outerBoundaryIs>  
                        <LinearRing>
                            <coordinates>
                            106.797494636567,4.653737046372933,0 
                            107.9105999951937,20.18311072920269,0 
                            92.41688357936664,21.16441251608377,0 
                            92.8508903014889,3.853973378567559,0 
                            106.797494636567,4.653737046372933,0 
                            </coordinates>
                        </LinearRing> 
                    </outerBoundaryIs> 
                </Polygon>
                <Style> 
                    <PolyStyle>  
                        <color>#a00000ff</color>
                        <outline>0</outline>
                    </PolyStyle> 
                </Style>
            </Placemark>
        </Document> 
    </kml>`;
    const blob = new Blob([content], { type: "text/plain" });
    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = "example.kml";
    a.click();

    URL.revokeObjectURL(url);
  };

  // const coop = async () => {
  //   let check = AuthService.operationco(
  //     coopUnit,
  //     CoopId,
  //     availableDroneID
  //   );
  //   if (check != null) check.then((res) => {});
  // };

  const convertTime = (dateTimeString) => {
    let dateAndTimeParts = dateTimeString.split("T");

    // Take the date part
    let datePart = dateAndTimeParts[0];

    // Take the time part and remove everything after "+"
    let timePart = dateAndTimeParts[1].split("+")[0];

    // Take only hours and minutes
    let [hours, minutes] = timePart.split(":").slice(0, 2);

    // Concatenate the date and time parts
    let formattedDateTime = `${datePart} ${hours}:${minutes}`;
    return formattedDateTime;
  };

  const findoperation = () => {
    // console.log(CoopId)
    let check = AuthServiceV3.FindAgencyOperation(CoopId);

    if (check != null)
      check.then((res) => {
        console.log("Response :", res.data);
        if (res.data.area != undefined || res.data.area != null) {
          const polygonString = res.data.area;
          const coordinatesString = polygonString.match(/\(([^)]+)\)/)[1];
          const coordinatesArray = coordinatesString
            .split(",")
            .map((coord) => coord.trim().split(" ").map(parseFloat));
          const lastElement = coordinatesArray.length - 1;
          coordinatesArray[0] = coordinatesArray[lastElement];
          console.log(coordinatesArray);
          const swappedCoordinatesArray = [];
          coordinatesArray.forEach((item) => {
            swappedCoordinatesArray.push([item[1], item[0]]);
          });
          setCoopArea(swappedCoordinatesArray);

          setCoopStartTime(convertTime(res.data.operation_start_time));
          setDayTimeStart(new Date(res.data.operation_start_time));
          setCoopEndTime(convertTime(res.data.operation_end_time));
          setDayTimeEnd(new Date(res.data.operation_start_time));

          getDrone();

          setIsCoopFound(true);
        } else {
          setCoopArea([]);
          setIsCoopFound(false);
          setCoopStartTime("");
          setCoopEndTime("");
        }
        //   const tempCoopData = [];
        //   for (
        //     let i = 0;
        //     i <
        //     res.data[0].operation_area.Volume3D.outline_polygon.vertices[0]
        //       .length;
        //     i++
        //   ) {
        //     tempCoopData.push([
        //       res.data[0].operation_area.Volume3D.outline_polygon.vertices[0][i]
        //         .Lat,
        //       res.data[0].operation_area.Volume3D.outline_polygon.vertices[0][i]
        //         .Lon,
        //     ]);
        //   }
        //   tempCoopData.push(tempCoopData[0]);

        //   setCoopArea(tempCoopData);
        //   setSearchcheck(1);

        //   setCoopTime([res.data[0].start_time, res.data[0].end_time]);
        //   getDrone();
        //   if (isCoopFound === true) {
        //     setIsCoopFound(false);
        //   }
        //   setIsCoopFound(true);
        // })
        // .catch(function (error) {
        //   if (error.response) {
        //     setSearchcheck(2);
        //   }
        //   setCoopArea([]);
        //   setIsCoopFound(false);
      });
  };

  const joinoperation = () => {
    let join = AuthServiceV3.JoinOperation(
      CoopId,
      dropdown_id,
      parseInt(chosenPilot.split("-")[0]),
      availableDroneID
    );
    if (join != null)
      join.then((res) => {
        console.log(res);
        setShowSuccess(true);
      });
  };

  const onEachFeature = (feature, layer) => {
    if (feature.properties && feature.properties.name) {
      layer.bindPopup(feature.properties.name);
    }
  };

  useEffect(() => {
    const handleWindowResize = () => {
      setWindowSize([window.innerWidth, window.innerHeight]);
    };
    window.addEventListener("resize", handleWindowResize);
    return () => {
      window.removeEventListener("resize", handleWindowResize);
      if (windowSize[0] < 800) {
        setSideBarToggle(false);
      } else {
        setSideBarToggle(true);
      }
    };
  }, [windowSize]);

  return (
    <div>
      <Modal
        show={showSuccess}
        onHide={() => {
          setEstimatedInfo([]);
          setShowSuccess(false);
          setConfirmSend(false);
        }}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            แจ้งเตือน
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>คุณได้ทำการบันทึกแผนการบินเรียบร้อย</Modal.Body>
        <Modal.Footer>
          <button
            onClick={() => {
              setShowSuccess(false);
              Navigate("/user/drone/updatepolygon", { state: {} });
              handleClose();
              Navigate("/user/drone/statusflightdrone");
              // setTimeout(() => {
              //   window.location.reload(false);
              // }, 500);
            }}
          >
            ปิด
          </button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={showSendcoop}
        onHide={() => {
          setEstimatedInfo([]);
          setShowSendcoop(false);
        }}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            <h3 style={{ color: "orange", letterSpacing: "1px" }}>
              JOINING PLANNING
            </h3>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h5>โดรนที่ท่านเลือก</h5>
          <h6>
            {`${selectedOption.toString().split("-")[1]}-${
              selectedOption.toString().split("-")[2]
            }`}
          </h6>
          <h5>รหัสการปฏิบัติการที่ท่านขอเข้าร่วม</h5>
          <h6>{CoopId}</h6>
          <div
            style={{
              width: "100%",
              height: "2px",
              backgroundColor: "black",
              marginTop: "5px",
              marginBottom: "5px",
            }}
          />
          <h5>วันและเวลาเริ่มต้น</h5>
          <h6>{coopStartTime}</h6>
          <h5>วันและเวลาสิ้นสุด</h5>
          <h6>{coopEndTime}</h6>
          <div
            style={{
              width: "100%",
              height: "2px",
              backgroundColor: "black",
              marginTop: "5px",
              marginBottom: "5px",
            }}
          />
          <h5>ความสูง</h5>
          <h6>{chosenHeight} เมตร</h6>
          <div
            style={{
              width: "100%",
              height: "2px",
              backgroundColor: "black",
              marginTop: "5px",
              marginBottom: "5px",
            }}
          />
          <p style={{ fontWeight: "bold" }}>
            คุณสามารถบันทึกแผนในระบบเพื่อแสดงเป็นหลักฐานแก่หน่วยงานที่เกี่ยวข้อง
            และสามารถแสดงเป็นรายงานแผนการบินได้
          </p>
        </Modal.Body>
        <Modal.Footer>
          <button
            style={{
              height: "50px",
              width: "30%",
              backgroundImage:
                "linear-gradient(97.41deg, #a50104 0%, #ff792b 100%)",
              display: "block",
              margin: "auto",

              borderRadius: "10px",
              fontWeight: "bold",
              fontSize: "20px",
              color: "white",
            }}
            onClick={() => {
              setShowSendcoop(false);
            }}
          >
            ยกเลิก
          </button>
          <button
            style={{
              height: "50px",
              width: "30%",
              backgroundColor: "red",
              display: "block",
              margin: "auto",

              borderRadius: "10px",
              backgroundImage: "linear-gradient(97.41deg, #023E8A, #0096C7)",
              fontWeight: "bold",
              fontSize: "20px",
              color: "white",
            }}
            onClick={() => {
              joinoperation();
            }}
          >
            ขออนุมัติแผน
          </button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={showSend}
        onHide={() => {
          setEstimatedInfo([]);
          setShowSend(false);
          setConfirmSend(false);
          getDrone();
        }}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            {estimatedInfo[1] === "READY || OPEN-DAY" ||
            estimatedInfo[1] === "READY || OPEN-NIGHT" ? (
              <h3 style={{ color: "green", letterSpacing: "1px" }}>OPEN</h3>
            ) : (
              <h3 style={{ color: "orange", letterSpacing: "1px" }}>
                SPECIFIC
              </h3>
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h5>โดรนที่ท่านเลือก</h5>
          <h6>
            {`${selectedOption.toString().split("-")[1]}-${
              selectedOption.toString().split("-")[2]
            }`}
          </h6>
          <h5>วัตถุประสงค์</h5>
          <h6>
            {selectedPurpose.length === 0
              ? null
              : selectedPurpose.split("-")[1]}
          </h6>
          <h5>วันและเวลาเริ่มต้น</h5>
          <h6>
            {("0" + dayTimeStart["$D"]).slice(-2)}/
            {("0" + (dayTimeStart["$M"] + 1)).slice(-2)}/{dayTimeStart["$y"]} -{" "}
            {("0" + dayTimeStart["$H"]).slice(-2)} :{" "}
            {("0" + dayTimeStart["$m"]).slice(-2)} : 00
          </h6>
          <h5>วันและเวลาสิ้นสุด</h5>
          <h6>
            {("0" + dayTimeEnd["$D"]).slice(-2)}/
            {("0" + (dayTimeEnd["$M"] + 1)).slice(-2)}/{dayTimeEnd["$y"]} -{" "}
            {("0" + dayTimeEnd["$H"]).slice(-2)} :{" "}
            {("0" + dayTimeEnd["$m"]).slice(-2)} : 00
          </h6>
          <div
            style={{
              width: "100%",
              height: "2px",
              backgroundColor: "black",
              marginTop: "5px",
              marginBottom: "5px",
            }}
          ></div>
          <h5>พื้นที่ที่เลือก (ลองจิจูด, ละติจูด)</h5>
          {chosenForm === 1 ? (
            <h6>{polygonArray.toString().substring(0, 54)}...</h6>
          ) : null}
          {chosenForm === 2 ? (
            <h6>{coopArea.toString().substring(0, 54)}...</h6>
          ) : null}
          {chosenForm === 3 && filename !== undefined ? (
            <h6>{simplifiedKMLPosition.toString().substring(0, 54)}...</h6>
          ) : null}

          <div
            style={{
              width: "100%",
              height: "2px",
              backgroundColor: "black",
              marginTop: "5px",
              marginBottom: "5px",
            }}
          ></div>
          <h5>ความสูง</h5>
          {chosenForm === 3 && filename !== undefined ? (
            <h6>{fileHeight} เมตร</h6>
          ) : (
            <h6>{chosenHeight} เมตร</h6>
          )}

          <div
            style={{
              width: "100%",
              height: "2px",
              backgroundColor: "black",
              marginTop: "5px",
              marginBottom: "5px",
            }}
          ></div>
          {estimatedInfo[1] === "READY || OPEN-DAY" ||
          estimatedInfo[1] === "READY || OPEN-NIGHT" ? (
            <p style={{ fontWeight: "bold" }}>
              คุณสามารถบันทึกแผนในระบบเพื่อแสดงเป็นหลักฐานแก่หน่วยงานที่เกี่ยวข้อง
              และสามารถแสดงเป็นรายงานแผนการบินได้
            </p>
          ) : (
            <p style={{ fontWeight: "bold" }}>
              แผนการบินของท่านจะถูกส่งให้แก่สำนักงานการบินพลเรือนแห่งประเทศไทยเพื่อให้
              หน่วยงานดังกล่าวตรวจสอบและอนุมัติแผนการบินพร้อมทั้งวัตถุประสงค์การบินข้างต้น
            </p>
          )}

          <div
            style={{
              width: "100%",
              height: "2px",
              backgroundColor: "black",
              marginTop: "5px",
              marginBottom: "5px",
            }}
          ></div>
          <div style={{ display: "flex" }}>
            <input
              style={{ width: "25px", height: "25px", margin: "auto 0px" }}
              type="checkbox"
              onChange={() => {
                if (confirmSend === false) {
                  setConfirmSend(true);
                } else {
                  setConfirmSend(false);
                }
              }}
            />
            <h4
              style={{
                fontWeight: "300",
                whiteSpace: "nowrap",
                margin: "auto 0px auto 10px",
              }}
            >
              คุณยอมรับกับข้อตกลงหรือไม่
            </h4>
          </div>
          <div
            style={{
              width: "100%",
              height: "2px",
              backgroundColor: "black",
              marginTop: "5px",
              marginBottom: "5px",
            }}
          ></div>
        </Modal.Body>
        <Modal.Footer>
          <button
            style={{
              height: "50px",
              width: "30%",
              backgroundImage:
                "linear-gradient(97.41deg, #a50104 0%, #ff792b 100%)",
              display: "block",
              margin: "auto",

              borderRadius: "10px",
              fontWeight: "bold",
              fontSize: "20px",
              color: "white",
            }}
            onClick={() => {
              setEstimatedInfo([]);
              handleClose();
              setConfirmSend(false);
            }}
          >
            ยกเลิก
          </button>
          {estimatedInfo[1] === "READY-DAY" ? (
            <button
              style={{
                height: "50px",
                width: "40%",
                backgroundColor: "red",
                display: "block",
                margin: "auto",

                borderRadius: "10px",
                backgroundImage: "linear-gradient(97.41deg, #023E8A, #0096C7)",
                fontWeight: "bold",
                fontSize: "20px",
                color: "white",
              }}
              onClick={() => {
                if (confirmSend === true) {
                  if (chosenForm === 1) {
                    confirmSendInfo();
                    handleClose();
                    setShowSuccess(true);
                    // window.location.reload(false);
                  }
                }
              }}
            >
              บันทึกแผน
            </button>
          ) : (
            <button
              style={{
                height: "50px",
                width: "50%",
                backgroundColor: "red",
                display: "block",
                margin: "auto",

                borderRadius: "10px",
                backgroundImage: "linear-gradient(97.41deg, #023E8A, #0096C7)",
                fontWeight: "bold",
                fontSize: "20px",
                color: "white",
              }}
              onClick={() => {
                if (confirmSend === true) {
                  confirmSendInfo();
                  handleClose();
                  setShowSuccess(true);
                  // window.location.reload(false);
                }
              }}
            >
              ส่งแบบร่างขออนุญาต
            </button>
          )}
        </Modal.Footer>
      </Modal>

      <Modal
        show={showError}
        onHide={() => {
          setShowError(false);
          setEstimatedInfo([]);
          setAreaIntersection("");
          getDrone();
        }}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            <h3 style={{ color: "red", letterSpacing: "1px" }}>โปรดตรวจสอบ</h3>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h4 style={{ color: "red" }}>- กรุณาเลือกตรวจสอบการกรอกข้อมูล</h4>
          {selectedOption.length === 0 ? (
            <h4 style={{ color: "red" }}>- กรุณาเลือกโดรน</h4>
          ) : null}
          {selectedPurpose.length === 0 ? (
            <h4 style={{ color: "red" }}>- กรุณาเลือกวัตถุประสงค์</h4>
          ) : null}
          {polygonArray.length === 0 && chosenForm === 1 ? (
            <h4 style={{ color: "red" }}>- กรุณาเลือกพื้นที่</h4>
          ) : null}
          {intersection === true ? (
            <h4 style={{ color: "red" }}>
              - กรุณาเลือก พื้นที่ที่ไม่ทับกัน {areaIntersection}
            </h4>
          ) : null}
          {chosenHeight <= 20 ? (
            <h4 style={{ color: "red" }}>- ต้องมีความสูงมากกว่า 20 เมตร</h4>
          ) : null}
          {chosenHeight >= 16000 ? (
            <h4 style={{ color: "red" }}>- ต้องมีความสูงไม่เกิน 16000 เมตร</h4>
          ) : null}
          {coopUnit.length === 0 && chosenForm === 2 ? (
            <h4 style={{ color: "red" }}>
              - กรุณากรอกรหัสการร่วมมือระหว่างหน่วยงาน
            </h4>
          ) : null}
          {isCoopFound === false && chosenForm === 2 ? (
            <h4 style={{ color: "red" }}>- รหัสหน่วยงานไม่ถูกต้อง</h4>
          ) : null}
          {filename === undefined && chosenForm === 3 ? (
            <h4 style={{ color: "red" }}>- โปรดเพิ่มไฟล์ kml, kmz</h4>
          ) : null}
          {estimatedInfo[1] === "REPEATED" ? (
            <h4 style={{ color: "red" }}>- คุณมีการปฏิบัติการในช่วงเวลานี้</h4>
          ) : null}
          {estimatedInfo[1] === "DRONE IN USED" ? (
            <h4 style={{ color: "red" }}>
              - โดรนที่ท่านเลือกกำลังถูกใช้งานในช่วงเวลานี้
            </h4>
          ) : null}
          {estimatedInfo[1] === "PILOT IN USED" ? (
            <h4 style={{ color: "red" }}>
              - นักบินที่ท่านเลือกกำลังปฏิบัติการในช่วงเวลานี้
            </h4>
          ) : null}
          {estimatedInfo[1] === "AREA IN USED" ? (
            <h4 style={{ color: "red" }}>
              - พื้นที่ที่ท่านเลือกกำลังมีการปฏิบัติการในช่วงเวลานี้
            </h4>
          ) : null}
          {estimatedInfo[1] === "INVALID PILOT TYPE" ? (
            <h4 style={{ color: "red" }}>
              - นักบินที่ท่านเลือกต้องเป็น 'SPECIFIC'
              เพื่อให้สอดคล้องกับวัตถุประสงค์การบิน
            </h4>
          ) : null}
          {estimatedInfo[1] === "OPEN PILOT ONLY" ? (
            <h4 style={{ color: "red" }}>
              - นักบินที่ท่านเลือกต้องเป็น 'OPEN'
              เพื่อให้สอดคล้องกับวัตถุประสงค์การบิน
            </h4>
          ) : null}
          {estimatedInfo[1] === "SPECIFIC PILOT ONLY" ? (
            <h4 style={{ color: "red" }}>
              - นักบินที่ท่านเลือกต้องเป็น 'SPECIFIC'
              เพื่อให้สอดคล้องกับวัตถุประสงค์การบิน
            </h4>
          ) : null}
          {wrongFormat === true && chosenForm === 3 ? (
            <>
              <h4 style={{ color: "red" }}>
                {wrongFormat}- กรุณาตรวจสอบรูปแบบของไฟล์ KML/KMZ
              </h4>
              {/* <button onClick={downloadTxtFile}>ดาวน์โหลดไฟล์ตัวอย่าง</button> */}
            </>
          ) : null}
        </Modal.Body>
      </Modal>

      <Modal
        show={loading}
        onHide={() => setLoading(false)}
        aria-labelledby="contained-modal-title-vcenter"
        size="sm"
        centered
      >
        <Modal.Body>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <span className="spinner-border spinner-border"></span>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        show={showErroroperation}
        onHide={() => setShowErroroperation(false)}
        aria-labelledby="contained-modal-title-vcenter"
        size="sm"
        centered
      >
        <Modal.Body>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            กรุณาขึ้นทะเบียนผู้ฎิบัติการก่อนค่ะ
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        show={showNoNight}
        onHide={() => setShowNoNight(false)}
        aria-labelledby="contained-modal-title-vcenter"
        size="sm"
        centered
      >
        <Modal.Body>
          <h4 style={{ color: "red" }}>กรุณาเลือกเวลาการบิน 7:00 - 17:00</h4>
        </Modal.Body>
      </Modal>
      <Modal
        show={showAgreement}
        onHide={() => {
          setShowAgreement(false);
        }}
        aria-labelledby="contained-modal-title-vcenter"
        size="xl"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            <h3>ข้อตกลงก่อนทำการบิน</h3>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <table
              style={{
                marginLeft: "auto",
                marginRight: "auto",
                width: "100%",
                fontSize: "20px",
              }}
            >
              <thead>
                <tr>
                  <th className="table-space">เนื้อหา</th>
                </tr>
              </thead>
              <tbody style={{ fontSize: "15px" }}>
                {agreementContent.map((content, index) => {
                  // Check if the current index is within the desired range
                  if (
                    (agreementPage - 1) * 5 <= index &&
                    index < agreementPage * 5
                  ) {
                    return (
                      <tr
                        key={index}
                        style={index % 2 === 0 ? { background: "#f2f2f2" } : {}}
                      >
                        <td
                          className="table-space"
                          style={{
                            width: "75%",
                            margin: "0px",
                            textAlign: "left",
                            paddingLeft: "25px",
                          }}
                        >
                          <p style={{ fontSize: "20px" }}>{content.text}</p>
                        </td>
                      </tr>
                    );
                  } else {
                    // It's important to return 'null' if you don't want anything rendered.
                    return null;
                  }
                })}
              </tbody>
            </table>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            style={{
              height: "50px",
              width: "30%",
              backgroundImage:
                "linear-gradient(97.41deg, #a50104 0%, #ff792b 100%)",
              display: "block",
              margin: "auto",

              borderRadius: "10px",
              fontWeight: "bold",
              fontSize: "20px",
              color: "white",
            }}
            onClick={() => {
              if (agreementPage > 1) {
                setAgreementPage(agreementPage - 1);
              } else {
                setShowAgreement(false);
                setShowSend(true);
              }
            }}
          >
            ย้อนกลับ
          </button>
          <button
            style={{
              height: "50px",
              width: "30%",
              backgroundColor: "red",
              display: "block",
              margin: "auto",

              borderRadius: "10px",
              backgroundImage: "linear-gradient(97.41deg, #023E8A, #0096C7)",
              fontWeight: "bold",
              fontSize: "20px",
              color: "white",
            }}
            onClick={() => {
              if (agreementPage > 6) {
                setShowAgreement(false);
                setAgreementPage(1);
                setShowSend(true);
              } else {
                setAgreementPage(agreementPage + 1);
              }
            }}
          >
            หน้าต่อไป
          </button>
        </Modal.Footer>
      </Modal>
      <Static_modal
        modalwaiting={modalToggle.modalwait}
        modalErr={modalToggle.modalErr}
        modalSuccess={modalToggle.modalSuccess}
        modalDenied={modalToggle.modalDenied}
        textBody={textBody}
        getHandle={handleClose_Modal}
      />
      <div className="flight-planning">
        <div style={{ height: "100%", width: "100%" }}>
          <MapContainer
            center={[13.101029105523143, 100.92994760607247]}
            zoom={13}
            keyboard={true}
            style={{ width: "100%", height: "100vh", zIndex: 1 }}
            ref={mapRef}
          >
            {/* {thailandProvince && (
              <GeoJSON
                data={thailandProvince}
                style={{
                  color: "orange",
                  fillColor: "yellow",
                  fillOpacity: 1,
                }}
              />
            )} */}
            {passedArea.length > 0 ? (
              <Polygon
                pathOptions={{
                  color: "red",
                  fillColor: "orange",
                  fillOpacity: 0.6,
                }}
                positions={passedArea}
              />
            ) : null}
            {coopArea && chosenForm === 2 ? (
              <Polygon
                pathOptions={{
                  color: "orange",
                  fillColor: "yellow",
                  fillOpacity: 0.6,
                }}
                positions={coopArea}
              />
            ) : null}
            {simplifiedKMLPosition.length > 0 ? (
              <Polygon
                pathOptions={{
                  color: "orange",
                  fillColor: "yellow",
                  fillOpacity: 0.6,
                }}
                positions={swapElements(simplifiedKMLPosition)}
              />
            ) : null}
            {timedReservedArea.length > 0 ? (
              <Polygon
                pathOptions={{
                  color: "orange",
                  fillColor: "yellow",
                  fillOpacity: 0.6,
                }}
                positions={quickSwapElement(timedReservedArea)}
              />
            ) : null}
            {coopArea.length > 0 ? (
              <Polygon
                pathOptions={{
                  color: "orange",
                  fillColor: "yellow",
                  fillOpacity: 0.6,
                }}
                positions={coopArea}
              />
            ) : null}
            {simplifiedKMLPosition.length > 0 ? null : (
              <FeatureGroup>
                <EditControl
                  position="topright"
                  onCreated={handleCreation}
                  onEdited={handleEdit}
                  onDeleted={handleDelete}
                  draw={{
                    polyline: false,
                    polygon:
                      polygonArray.length === 0
                        ? {
                            allowIntersection: false,
                            showArea: true,
                            showLength: true,
                            metric: ["km", "m"],
                            shapeOptions: {
                              color: "green",
                              fillColor: "lightgreen",
                              fillOpacity: 0.6,
                            },
                          }
                        : false,
                    rectangle: false,
                    circle:
                      polygonArray.length === 0
                        ? {
                            shapeOptions: {
                              color: "green",
                              fillColor: "lightgreen",
                              fillOpacity: 0.6,
                            },
                          }
                        : false,
                    marker: false,
                    circlemarker: false,
                  }}
                  edit={{
                    delete: true,
                    edit: true,
                  }}
                />
              </FeatureGroup>
            )}

            <Control position="topright">
              <button
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "35px",
                  width: "35px",
                  backgroundColor: "white",
                  borderWidth: "1px",
                  borderColor: "grey",
                  color: "black",
                }}
                className="btn btn-primary"
                onClick={showMyLocation}
              >
                <GoLocation />
              </button>
            </Control>
            <Control position="bottomleft">
              {populationShow === false ? (
                <div
                  style={{
                    width: "300px",
                    backgroundColor: "white",
                    borderWidth: "1px",
                    borderColor: "grey",
                    color: "black",
                  }}
                >
                  <label style={{ paddingLeft: "25px", fontSize: "20px" }}>
                    <input
                      style={{
                        marginRight: "5px",
                        height: "20px",
                        width: "20px",
                      }}
                      type="checkbox"
                      checked={populationShow}
                      onChange={() => {
                        if (populationShow === false) {
                          setPopulationShow(true);
                        } else {
                          setPopulationShow(false);
                        }
                      }}
                    />
                    ข้อมูลความหนาแน่นประชาชน
                  </label>
                </div>
              ) : (
                <div
                  style={{
                    width: "250px",
                    backgroundColor: "white",
                    borderWidth: "1px",
                    borderColor: "grey",
                    color: "black",
                  }}
                >
                  <div
                    style={{
                      justifyContent: "center",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <label style={{ fontSize: "16px", margin: "0px auto" }}>
                      <input
                        style={{
                          marginRight: "5px",
                          height: "15px",
                          width: "15px",
                        }}
                        type="checkbox"
                        checked={populationShow}
                        onChange={() => {
                          if (populationShow === false) {
                            setPopulationShow(true);
                          } else {
                            setPopulationShow(false);
                          }
                        }}
                      />
                      ข้อมูลความหนาแน่นประชาชน
                    </label>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      paddingTop: "10px",
                    }}
                  >
                    สีของความหนาแน่นประชาชน
                  </div>
                  <div
                    style={{
                      paddingTop: "10px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      paddingBottom: "10px",
                    }}
                  >
                    <table>
                      <thead>
                        <tr>
                          <th style={{ padding: "0px 10px" }}>สี</th>
                          <th style={{ padding: "0px 10px" }}>จำนวนประชากร</th>
                        </tr>
                      </thead>
                      <tbody>
                        {legendPopulation.map((item, index) => (
                          <tr key={index}>
                            <td
                              style={{
                                color: "red",
                                opacity: item.color,
                                padding: "0px 10px",
                              }}
                            >
                              <FaCircle />
                            </td>
                            <td style={{ padding: "0px 10px" }}>
                              {item.population}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </Control>
            <LayersControl position="bottomright">
              <LayersControl.BaseLayer name="Google Map">
                <TileLayer
                  style={{ zIndex: 2 }}
                  url="http://www.google.cn/maps/vt?lyrs=s@189&gl=cn&x={x}&y={y}&z={z}"
                />
              </LayersControl.BaseLayer>
              <LayersControl.BaseLayer checked name="OpenStreet Map">
                <TileLayer
                  style={{ zIndex: 2 }}
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
              </LayersControl.BaseLayer>
              <LayersControl.BaseLayer name="OpenToPo Map">
                <TileLayer
                  style={{ zIndex: 2 }}
                  url="https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png"
                />
              </LayersControl.BaseLayer>
              <LayersControl.BaseLayer name="ThunderForest Map">
                <TileLayer
                  style={{ zIndex: 2 }}
                  url="https://tile.thunderforest.com/landscape/{z}/{x}/{y}.png
"
                />
              </LayersControl.BaseLayer>

              {/* <LayersControl.Overlay checked name="Bangkok Population">
                {bangkokPopulation && (
                  <GeoJSON
                    data={bangkokPopulation}
                    style={bangkokPopulationColorized}
                    onEachFeature={onEachFeature}
                  />
                )}
              </LayersControl.Overlay> */}

              <LayersControl.Overlay checked name="Aerodome area">
                {Aerodrome && (
                  <GeoJSON
                    data={Aerodrome}
                    style={{
                      color: "orange",
                      fillColor: "orange",
                      fillOpacity: 0.5,
                    }}
                    onEachFeature={onEachFeature}
                  />
                )}
              </LayersControl.Overlay>
              <LayersControl.Overlay checked name="Flight prohibitation area">
                {PDRArea && (
                  <GeoJSON
                    data={PDRArea}
                    style={{
                      color: "red",
                      fillColor: "red",
                      fillOpacity: 0.5,
                    }}
                    onEachFeature={onEachFeature}
                  />
                )}
              </LayersControl.Overlay>
              <LayersControl.Overlay checked name="Hospital area">
                {hospital && (
                  <GeoJSON
                    data={hospital}
                    style={{
                      color: "purple",
                      fillColor: "purple",
                      fillOpacity: 0.5,
                    }}
                    onEachFeature={onEachFeature}
                  />
                )}
              </LayersControl.Overlay>
              <LayersControl.Overlay checked name="Goverment Office area">
                {govOffice && (
                  <GeoJSON
                    data={govOffice}
                    style={{
                      color: "blue",
                      fillColor: "blue",
                      fillOpacity: 0.5,
                    }}
                    onEachFeature={onEachFeature}
                  />
                )}
              </LayersControl.Overlay>
              <LayersControl.Overlay checked name="Embassy area">
                {embassy && (
                  <GeoJSON
                    data={embassy}
                    style={{
                      color: "yellow",
                      fillColor: "yellow",
                      fillOpacity: 0.5,
                    }}
                    onEachFeature={onEachFeature}
                  />
                )}
              </LayersControl.Overlay>
              <LayersControl.Overlay checked name="Police department area">
                {policeDepartment && (
                  <GeoJSON
                    data={policeDepartment}
                    style={{
                      color: "green",
                      fillColor: "green",
                      fillOpacity: 0.5,
                    }}
                    onEachFeature={onEachFeature}
                  />
                )}
              </LayersControl.Overlay>
              <LayersControl.Overlay checked name="Thai Goverment area">
                {thaiGov && (
                  <GeoJSON
                    data={thaiGov}
                    style={{
                      color: "red",
                      fillColor: "red",
                      fillOpacity: 1,
                    }}
                    onEachFeature={onEachFeature}
                  />
                )}
              </LayersControl.Overlay>
              {bangkokPopulation && populationShow === true ? (
                <GeoJSON
                  data={bangkokPopulation}
                  style={bangkokPopulationColorized}
                  onEachFeature={onEachFeature}
                />
              ) : null}
            </LayersControl>
          </MapContainer>
        </div>
        <div className="menu-bar">
          {chosenForm === 1 ? (
            <div className="form-content">
              <div className="special-input-section">
                <h5>เวลาเริ่มต้นการบิน</h5>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DateTimePicker
                    slotProps={{
                      textField: {
                        sx: {
                          "& .MuiInputBase-sizeSmall": {
                            height: "40px",
                            fontSize: "20px",
                            borderWidth: "0px",
                            borderRadius: "100px",
                          },
                        },
                        size: "small",
                      },
                    }}
                    ampm={false}
                    closeOnSelect={true}
                    shouldDisableDate={shouldDisableStartDate}
                    shouldDisableTime={shouldDisableTime}
                    value={dayTimeStart}
                    // minDateTime={dayjs().startOf('day').set('hour', 6)} // Set minimum time to 6:00
                    // maxDateTime={dayjs().startOf('day').set('hour', 17).set('minute', 59)} // Set maximum time to 17:59
                    onClose={() => {
                      getDrone();
                      setTimeout(() => {
                        setIsTimeBeingSet(!isTimeBeingSet);
                      }, 500);
                    }}
                    onChange={handleChangeStart}
                  />
                </LocalizationProvider>
              </div>
              <div className="special-input-section">
                <h5>เวลาสิ้นสุดการบิน</h5>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DateTimePicker
                    slotProps={{
                      textField: {
                        sx: {
                          "& .MuiInputBase-sizeSmall": {
                            height: "40px",
                            fontSize: "20px",
                            borderWidth: "0px",
                            borderRadius: "100px",
                          },
                        },
                        size: "small",
                      },
                    }}
                    ampm={false}
                    closeOnSelect={true}
                    shouldDisableTime={(date) => {
                      return (
                        date < dayTimeStart ||
                        date > dayTimeStart.add(3, "hour") ||
                        new Date(date).getHours() >= 17
                      );
                    }}
                    shouldDisableDate={(date) => {
                      return (
                        date < dayTimeStart.add(-24, "hour") ||
                        date > dayTimeStart.add(3, "hour")
                      );
                    }}
                    value={dayTimeEnd}
                    onClose={() => {
                      // getPolygonPosition();
                      getDrone();
                      setTimeout(() => {
                        setIsTimeBeingSet(!isTimeBeingSet);
                      }, 500);
                    }}
                    onChange={handleChangeEnd}
                  />
                </LocalizationProvider>
              </div>
              <div className="input-section">
                <h5>เลือกอากาศยาน</h5>
                <select
                  value={selectedOption.toString()}
                  className="dropdown-field"
                  onChange={(event) => {
                    setAvailableDroneID(
                      parseInt(event.target.value.substring(0, 2))
                    );

                    setAvailablePurpose(
                      tempAvailablePurpose[
                        parseInt(event.target.value.substring(0, 2))
                      ]
                    );

                    setSelectedOption([event.target.value]);
                  }}
                >
                  <option value="" disabled>
                    เลือกโดรนที่จะเข้าร่วม
                  </option>
                  <option value="">-</option>
                  {availableDrone.map((option, index) => (
                    <option key={index} value={option}>
                      {`${option.split("-")[1]}-${option.split("-")[2]}`}
                    </option>
                  ))}
                </select>
              </div>
              <div className="input-section">
                <h5>เลือกวัตถุประสงค์การบิน</h5>
                <select
                  value={selectedPurpose.toString()}
                  className="dropdown-field"
                  onChange={(event) => {
                    setSelectedPurpose(event.target.value);
                  }}
                >
                  <option value="" disabled>
                    เลือกวัตถุประสงค์ของคุณ
                  </option>
                  <option value="">-</option>
                  {availablePurpose !== undefined ? (
                    <>
                      {availablePurpose.map((option, index) => {
                        const purposeIndex = fetchedPurpose.findIndex(
                          (item) => item.purpose_id === option
                        );
                        if (purposeIndex != -1 && purposeIndex < 6) {
                          const key = parseInt(
                            fetchedPurpose[purposeIndex].purpose_id
                          );
                          return (
                            <option
                              key={key}
                              value={`${key}-${
                                fetchedPurpose[key - 1].purpose
                              }`}
                            >
                              {fetchedPurpose[key - 1].purpose}
                            </option>
                          );
                        } else if (Array.isArray(option)) {
                          return (
                            <option key={7} value={`${7}-${option[1]}`}>
                              {option[1]}
                            </option>
                          );
                        } else {
                          return null;
                        }
                      })}
                    </>
                  ) : null}
                </select>
              </div>
              <div className="input-section">
                <h5>เลือกนักบิน</h5>
                <select
                  value={chosenPilot.toString()}
                  className="dropdown-field"
                  onChange={(event) => {
                    setChosenPilot(event.target.value);
                  }}
                >
                  <option value="" disabled>
                    เลือกนักบินที่จะเข้าร่วม
                  </option>
                  <option value="">-</option>
                  {availablePilot.map((option, index) => {
                    if (
                      parseInt(selectedPurpose.split("-")[0]) < 5 &&
                      option.split("-")[2] === "OPEN"
                    ) {
                      return (
                        <option key={index} value={option}>
                          {`${option.split("-")[1]} - ${option.split("-")[2]}`}
                        </option>
                      );
                    } else if (
                      parseInt(selectedPurpose.split("-")[0]) >= 5 &&
                      option.split("-")[2] === "SPECIFIC"
                    ) {
                      return (
                        <option key={index} value={option}>
                          {`${option.split("-")[1]} - ${option.split("-")[2]}`}
                        </option>
                      );
                    }
                  })}
                </select>
              </div>
           
              <div className="input-section">
                <h5>ตำแหน่งพื้นที่</h5>
                <input value={polygonArray} readOnly></input>
                <input
                  style={{
                    display: "none",
                  }}
                  id="myFileInput"
                  alt="inputdata"
                  type="file"
                  accept=".kml,.kmz"
                  ref={hiddenFileInput}
                  onChange={handleFileInputChange}
                />
                {simplifiedKMLPosition.length > 0 ? (
                  <h6
                    style={{
                      color: "red",
                      textDecoration: "underline",
                      cursor: "pointer",
                    }}
                    onClick={(e) => {
                      setSimplifiedKMLPosition([]);
                      setFilename(null);
                      setPolygonArray([]);
                    }}
                  >
                    <MdCancel /> ยกเลิก {filename}
                  </h6>
                ) : (
                  <div>
                    {polygonArray.length > 0 ? (
                      <h6
                        style={{
                          color: "red",
                          textDecoration: "underline",
                        }}
                      >
                        <MdCancel /> ยกเลิกตำแหน่งเพื่ออัพโหลดไฟล์ KML
                      </h6>
                    ) : (
                      <h6
                        style={{
                          textDecoration: "underline",
                          cursor: "pointer",
                        }}
                        onClick={(e) => {
                          hiddenFileInput.current.click();
                        }}
                      >
                        <AiOutlineFileAdd />
                        อัพโหลดไฟล์ KML (ถ้ามี)
                      </h6>
                    )}
                  </div>
                )}
              </div>
              <div className="button-section">
                <button
                  onClick={() => {
                    checkAllPolygon();
                  }}
                >
                  ประเมินแผน
                </button>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default UpdatePolygon;
